import { useState } from 'react'
import { MessageSquare, Plus } from 'lucide-react'
import { WhatsAppMailboxList } from '@components/whatsapp/WhatsAppMailboxList'
import { WhatsAppMailboxForm } from '@components/whatsapp/WhatsAppMailboxForm'
import { WhatsAppMailbox } from '@/types'

export function WhatsAppMailboxesPage() {
  const [showForm, setShowForm] = useState(false)
  const [editingMailbox, setEditingMailbox] = useState<WhatsAppMailbox | null>(null)

  const handleEdit = (mailbox: WhatsAppMailbox) => {
    setEditingMailbox(mailbox)
    setShowForm(true)
  }

  const handleCloseForm = () => {
    setShowForm(false)
    setEditingMailbox(null)
  }

  const handleFormSuccess = () => {
    // Form will handle closing itself after success
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <MessageSquare size={32} className="text-primary" />
          <h1 className="text-3xl font-bold text-gray-900">WhatsApp Mailboxes</h1>
        </div>
        <button
          onClick={() => {
            setEditingMailbox(null)
            setShowForm(true)
          }}
          className="flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 font-medium text-white hover:bg-primary/90"
        >
          <Plus size={20} />
          Add WhatsApp Mailbox
        </button>
      </div>

      <WhatsAppMailboxList onEdit={handleEdit} />

      {showForm && (
        <WhatsAppMailboxForm
          mailbox={editingMailbox}
          onClose={handleCloseForm}
          onSuccess={handleFormSuccess}
        />
      )}
    </div>
  )
}
